import setupTrackingEpic from '@clearscore/epic.tracking';
import setupTrackingMiddleWare from '@clearscore/redux.tracking-middleware';

import config from './config';

export const trackingEpic = setupTrackingEpic(config);
export const trackingMiddleware = setupTrackingMiddleWare(config);
